import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-86bab60c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OrdersListItem__header" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "header__title header--left ml-3" }
const _hoisted_4 = { class: "header__company header--right" }
const _hoisted_5 = { class: "OrdersListItem__container mt-1" }
const _hoisted_6 = { class: "container__block items-start" }
const _hoisted_7 = { class: "container__text" }
const _hoisted_8 = { class: "container__text" }
const _hoisted_9 = { class: "container__text" }
const _hoisted_10 = { class: "container__text" }
const _hoisted_11 = { class: "container__block right" }
const _hoisted_12 = { class: "container__text text--large" }
const _hoisted_13 = { class: "container__text" }
const _hoisted_14 = { class: "flex items-center justify-between" }
const _hoisted_15 = { class: "flex flex-col" }
const _hoisted_16 = { class: "flex flex-wrap" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: "OrdersListItem",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emitClick && _ctx.emitClick(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_checkbox, {
          onClick: _withModifiers(_ctx.emitCheck, ["stop"]),
          value: _ctx.checked
        }, null, 8, ["onClick", "value"]),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.item.id), 1)
      ]),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.item.company_name), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.item.full_address), 1),
        _createElementVNode("span", _hoisted_8, "Номер 1С: " + _toDisplayString(_ctx.item.number_1c), 1),
        _createElementVNode("span", _hoisted_9, " Период забора: " + _toDisplayString(_ctx.item.period_title || 'Нет данных'), 1),
        _createElementVNode("span", _hoisted_10, " Комментарий отправителя: " + _toDisplayString(_ctx.item.sender_comment || 'Нет данных'), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.item.sender_full_name), 1),
        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.item.sender_phone), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.take_statuses, (status, idx) => {
            return (_openBlock(), _createElementBlock("span", {
              key: `key-${idx}`,
              class: "mt-2"
            }, [
              status
                ? (_openBlock(), _createBlock(_component_cheap, {
                    key: 0,
                    class: _normalizeClass(["small mr-2 w-max", {
                                red: status.key === 'not_assigned',
                                primary: status.key === 'assigned_to_courier',
                                green: status.key === 'cargo_handling',
                                yellow: status.key === 'taken',
                            }])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.DispatcherOrderStatusesEnum[status.key]), 1)
                    ]),
                    _: 2
                  }, 1032, ["class"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        (_ctx.item.states.length > 0)
          ? (_openBlock(), _createBlock(_component_cheap, {
              key: 0,
              class: "primary small mt-2"
            }, {
              default: _withCtx(() => [
                (Boolean(_ctx.item.courier))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.item.courier.full_name), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                _createTextVNode(" (" + _toDisplayString(_ctx.item.states[_ctx.item.states.length - 1].title) + " " + _toDisplayString(_ctx.item.states[_ctx.item.states.length - 1].date) + ") ", 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.item.wait_list_status)
          ? (_openBlock(), _createBlock(_component_cheap, {
              key: 1,
              class: "primary small mt-2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.item.wait_list_status), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_the_button, {
        class: "primary small text",
        onClick: _withModifiers(_ctx.emitCheck, ["stop"])
      }, {
        default: _withCtx(() => [
          _hoisted_17,
          _createTextVNode(" Выбрать ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}